import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { Grid } from '@material-ui/core'

import ProjectsDataTable from './components/ProjectsDataTable/ProjectsDataTable'

import AddProjectDialog from './components/AddProjectDialog/AddProjectDialog';

import { ToggleAddProjectDialog } from '../../../../actions/OperatorsActions.js';

const useStyles = makeStyles((theme) => ({
    root: {},
    deliverables: {
        marginTop: theme.spacing(3),
    },
    members: {
        marginTop: theme.spacing(3),
    },
}))

const Projects = (props) => {
    const { operator, className, ...rest } = props
    const classes = useStyles();
    const dispatch = useDispatch();
    const openAddProjectDialog = useSelector((state) => state.operatorsReducer.openAddProjectDialog);

    const _addProjectClose = () => {
        dispatch(ToggleAddProjectDialog(false))
    }


    return (
        <Grid
            {...rest}
            className={clsx(classes.root, className)}
            container
            spacing={3}>
            <Grid item lg={12} md={12} xl={12} xs={12}>
                <ProjectsDataTable data={operator.projectList} operatorId={operator.id} />
            </Grid>
            {openAddProjectDialog && <AddProjectDialog
                onClose={_addProjectClose}
                open={openAddProjectDialog}
                operatorId={operator.id}
            />}
        </Grid>
    )
}

Projects.propTypes = {
    className: PropTypes.string,
    Projects: PropTypes.array.isRequired,
}

export default Projects
